import React from 'react'
import { Stack, Typography } from '@mui/material'
import { ComparisonTableCellProps } from './_props'
import sxs from './ComparisonTableCell.sxs'
import { stateProps } from './_utils'

const ComparisonTableCell: React.FC<ComparisonTableCellProps> = ({
    type = 'default',
    state,
    label,
    helperText,
    icon,
    flex = 2,
}) => {
    const statusProps = state ? stateProps[state] : undefined
    const isHeaderCell = !statusProps && type === 'header'

    const cellSxs = {
        ...sxs.comparisonTableCellBase,
        ...(isHeaderCell ? sxs.comparisonTableCellHeader : statusProps?.classes),
    }

    return (
        <Stack flex={flex} flexDirection="row" alignItems="center" gap="0.75rem" sx={cellSxs}>
            {icon}
            <Stack justifyContent="center">
                <Typography>{label}</Typography>
                <Typography sx={sxs.comparisonTableCellHelperText}>{helperText}</Typography>
            </Stack>
        </Stack>
    )
}
export default ComparisonTableCell
